<template>
  <main class="container container-final d-flex flex-column">

    <CheckBoxComponent @onClick="isRoundTrip" :state="roundTrip" :id="'roundTrip'" name="roundTrip"
                       class="checkbox-default mb-4">
      <template #checkbox-text>
        <label class="ml-5" for="roundTrip">{{ $t('round_trip') }}</label>
      </template>
    </CheckBoxComponent>

    <TransportationComponent :round-trip="roundTrip"></TransportationComponent>

    <div id="main-transportation-title" class="d-flex flex-column align-items-center justify-content-center">
      <div class="font-big mt-5 transportation-title">{{ $t('passenger_transportation') }}</div>
      <h3 class="font-weight-600">{{ pickUp.city }} - {{ dropOff.city }}</h3>
    </div>

    <div class="row row-cols-2 justify-content-center">
      <TransportationTicketComponent
          :is-forward-ticket="true"
          :display-props="{ imgUrl: '/images/next-arrow.svg', placeholder: 'choose_ticket_forward' }"
          :forward-ticket="forwardTicket"
      />
      <TransportationTicketComponent
          :is-forward-ticket="false"
          :display-props="{ imgUrl: '/images/previous-arrow.svg', placeholder: 'choose_ticket_back' }"
          :back-ticket="backTicket"
      />
    </div>

    <div class="d-flex justify-content-center tickets-button-container">
      <div class="d-flex flex-column align-items-end m-0 tickets-button-container__inner-first">
        <template v-if="error.message">
          <div class="font-small error-color">
            {{ $t(error.message) }}
          </div>
        </template>
        <ButtonComponent class="order-form-submit-button final-button-margin tickets-button-container__inner-first__inner-second" @click="onOrder">
          <template #btnContent>
            {{ $t('order_now') }}
          </template>
        </ButtonComponent>
      </div>
    </div>

  </main>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {mapState, useStore} from "vuex";
import axios from "axios";
import apiService from "../../services/apiService";
import {routesConst} from "../../routes";

import type {IOrderState} from "@/store/states/IOrderState.interface";
import type {IOrderTrueRoundTripState} from "@/store/states/IOrderTrueRoundTripState.interface";

// @ts-ignore
import TransportationTicketComponent from "../../components/transportationTicket/TransportationTicketComponent.vue";
// @ts-ignore
import ButtonComponent from "../../components/Button/ButtonComponent.vue";
// @ts-ignore
import TransportationComponent from "../../components/Forms/Transportation/TransportationComponent.vue";
// @ts-ignore
import CheckBoxComponent from "../../components/CheckBox/CheckBoxComponent.vue";
import type { ITicket } from "@/interfaces/ITicket.interface";
import {dateHelpers} from "../../helpers/dateHelpers";


export default defineComponent({
  name: 'RoundTripFinalStepPage',

  components: {
    ButtonComponent,
    TransportationTicketComponent,
    TransportationComponent,
    CheckBoxComponent
  },

  setup() {
    const store = useStore();

    return {
      store
    }
  },

  data() {
    return {
      testState: true,
      error: { message: '' }
    }
  },

  computed: {
    ...mapState<IOrderState>('order', {
      roundTrip: state => state.roundTrip
    }),
    ...mapState<IOrderTrueRoundTripState>('orderTrueRoundTrip', {
      pickUp: state => state.pickUp,
      dropOff: state => state.dropOff,
      forwardTicket: (state: IOrderTrueRoundTripState): ITicket => state.forwardTicket,
      backTicket: state => state.backTicket,
    }),

    // TODO NEED TO EXPLORE MORE
    // isSelected(): ITicket {
    //   return this.selectedForwardTicket;
    // }

  },

  methods: {
    isRoundTrip: function ($event: {target: HTMLInputElement}): void {
      this.store.dispatch('order/updateInitStates', [{prop: 'roundTrip', value: $event.target.checked}]);

      this.$router.push(routesConst.TRIPS);
    },
    onOrder() {
      const state = this.store.state.orderTrueRoundTrip;

      let diff = dateHelpers.differenceBetweenTwoDates(state.forwardTicket.tripDate, state.backTicket.tripDate);

      if (state.forwardTicket.isSelected && state.backTicket.isSelected && diff >= 1) {
        this.$router.push(routesConst.ORDER);
      } else {
        this.error.message = 'mainFormData.backTicket.tripDate.validation.after_or_equal';
        return;
      }

      state.forwardTicket.isSelected && state.backTicket.isSelected ?
          this.$router.push(routesConst.ORDER) :
          this.$router.push(routesConst.ROUND_TRIP_FIRST_STEP);
    }
  },

  created() {
    axios.get(apiService.pageRoundTripFinalStepPageEndpoint())
        .then((response) => {
          // ...
        });
  }
})
</script>

<style scoped lang="scss">
@import './roundTripFinalStep.scss';

</style>